<div class="flex flex-col h-full gap-y-4 overflow-hidden px-0 lg:px-10 py-4">
  <div class="flex justify-between items-end shrink-0">
    <div class="font-semibold text-xl text-(--color-text-primary)">Pedidos entregados</div>

    <button
      (click)="closeModal()"
      class="border! rounded-full border-(--comp-dialog-button-close)!"
      mat-icon-button
    >
      <mat-icon class="text-(--comp-dialog-button-close)!">close</mat-icon>
    </button>
  </div>

  <div
    class="general-simple-box flex-1 min-h-0 flex flex-col"
    [ngClass]="{ ' ': !mobile, 'gap-1': mobile }"
  >
    <div class="flex-1 min-h-0 overflow-y-auto px-2" (scroll)="onScrollClosedTickets($event)">
      <div class="flex gap-4 flex-col lg:flex-row lg:flex-wrap">
        @for (card of getcloseTicketDetailList(); track card) {
          <div class="flex gap-4">
            <app-expancion-card
              [folio]="card[0]?.Key || ''"
              [mobile]="mobile"
              [date]="card[0]?.ClosingDate || ''"
              [ticketPendingSupply]="ticketPendingSupply[$index]"
            >
            </app-expancion-card>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<app-load-general [load]="isLoading"></app-load-general>
